<template>
  <v-container fluid class="admin-settings" v-if="settings">
    <v-tabs>
      <v-tab>
        T&C
      </v-tab>
      <v-tab-item>
        <v-container class="admin-settings-tnc-wrapper" v-if="tnc">
          <b-form-group :label="$t('admin_tnc.title_en')"
                        horizontal>
            <b-form-input v-model="tnc.title_en"></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.content_en')"
                        horizontal>
            <TinyMceEditor v-model="tnc.content_en"
                           allow-all-style></TinyMceEditor>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.title_zh')"
                        horizontal>
            <b-form-input v-model="tnc.title_zh"></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.content_zh')"
                        horizontal>
            <TinyMceEditor v-model="tnc.content_zh"
                           allow-all-style></TinyMceEditor>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.privacy_title_en')"
                        horizontal>
            <b-form-input v-model="tnc.privacy_title_en"></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.privacy_content_en')"
                        horizontal>
            <TinyMceEditor v-model="tnc.privacy_content_en"
                           allow-all-style></TinyMceEditor>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.privacy_title_zh')"
                        horizontal>
            <b-form-input v-model="tnc.privacy_title_zh"></b-form-input>
          </b-form-group>

          <b-form-group :label="$t('admin_tnc.privacy_content_zh')"
                        horizontal>
            <TinyMceEditor v-model="tnc.privacy_content_zh"
                           allow-all-style></TinyMceEditor>
          </b-form-group>

          <v-row class="mt-3">
            <v-col>
              <b-button variant="primary" @click="saveTNC">{{ $t('save') }}</b-button>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab>
        {{ $t('admin.acc_booking') }}
      </v-tab>
      <v-tab-item>
        <v-container class="admin-settings-inner-wrapper">
          <v-row>
            <v-col>
              <b-form class="admin-booking-detail-form">
                <b-form-group v-for="field in fields"
                              :key="field"
                              :label="$t(`admin_acc_settings.${field}`)"
                              horizontal>
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <input type="checkbox"
                             @change="onCheckboxChecked($event, field)"
                             :checked="disabled.indexOf(field) !== -1"
                             class="mr-2"> {{ $t('disable') }}
                    </b-input-group-prepend>
                    <b-form-input type="number" :min="1" :step="1" v-model="settings[field]" :disabled="disabled.indexOf(field) !== -1"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <b-form-group :label="$t(`admin_acc_settings.acc_point_top_up_options`)"
                            horizontal>
                <v-row v-for="(tier, index) in topUpOptions">
                  <v-col>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        HKD
                      </b-input-group-prepend>
                      <b-form-input v-model="tier.price" :placeholder="$t('admin_acc_settings.top_up_tier_price')" type="number" min="1"></b-form-input>
                    </b-input-group>
                  </v-col>
                  <v-col>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        Point
                      </b-input-group-prepend>
                      <b-form-input v-model="tier.amount" :placeholder="$t('admin_acc_settings.top_up_tier_amount')" type="number" min="1"></b-form-input>
                      <b-input-group-append>
                        <b-button @click="removeTopUpTier(index)">
                          <font-awesome-icon icon="times"></font-awesome-icon>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </v-col>
                </v-row>
                <b-row>
                  <b-col>
                    <b-button block @click="addTopUpTier">{{ $t('admin_acc_settings.add_top_up_tier') }}</b-button>
                  </b-col>
                </b-row>
              </b-form-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <b-form-group :label="$t('admin_acc_settings.acc_point_exchange_rate')"
                            horizontal>
                <b-input-group>
                  <b-input-group-prepend is-text>
                    1 HKD:
                  </b-input-group-prepend>
                  <b-form-input type="number" :min="1" :step="1" v-model="settings.acc_point_exchange_rate"></b-form-input>
                  <b-input-group-append is-text>
                    POINTS
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group :label="$t(`admin_acc_settings.acc_max_gym_reservation`)"
                            horizontal>
                <b-input-group>
                  <b-form-input type="number" :min="0" :step="1" v-model="settings.acc_max_gym_reservation"></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group :label="$t(`admin_acc_settings.acc_max_gym_capacity`)"
                            horizontal>
                <b-input-group>
                  <b-form-input type="number" :min="0" :step="1" v-model="settings.acc_max_gym_capacity"></b-form-input>
                </b-input-group>
              </b-form-group>
            </v-col>
          </v-row>

          <b-form-group :label="$t('admin_acc_invoice.invoice_pdf_footer')"
                        horizontal>
            <TinyMceEditor v-model="settings.invoice_pdf_footer"
                           allow-all-style></TinyMceEditor>
          </b-form-group>
          <b-form-group :label="$t('admin_acc_invoice.invoice_bank_transfer_payment_instructions')"
                        horizontal>
            <TinyMceEditor v-model="settings.invoice_bank_transfer_payment_instructions"></TinyMceEditor>
          </b-form-group>
          <b-form-group :label="$t('admin_acc_invoice.invoice_cheque_payment_instructions')"
                        horizontal>
            <TinyMceEditor v-model="settings.invoice_cheque_payment_instructions"></TinyMceEditor>
          </b-form-group>
          <b-form-group :label="$t('admin_acc_invoice.receipt_pdf_footer')"
                        horizontal>
            <TinyMceEditor v-model="settings.receipt_pdf_footer"></TinyMceEditor>
          </b-form-group>

          <v-row class="mt-3">
            <v-col>
              <b-button variant="primary" @click="saveSettings">{{ $t('save') }}</b-button>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab>
        {{ $t('admin_home_page.title') }}
      </v-tab>
      <v-tab-item>
        <HkiaraceHomePageSetting></HkiaraceHomePageSetting>
      </v-tab-item>

      <v-tab>
        {{ $t('admin_home_page.banner') }}
      </v-tab>
      <v-tab-item>
        <!--        <HkiaraceBannerSetting></HkiaraceBannerSetting>-->
        <HkiaraceBanner></HkiaraceBanner>
      </v-tab-item>

      <v-tab>
        {{ $t('admin_home_page.maintenance_mode') }}
      </v-tab>
      <v-tab-item>
        <v-container class="admin-settings-inner-wrapper" v-if="maintenance">
          <v-row>
            <v-col>
              <b-form-group :label="$t('admin_home_page.maintenance_status')">
                <b-form-input disabled :value="currentMaintenanceStatus"></b-form-input>
              </b-form-group>

            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col>
              <v-btn color="primary" @click="startMaintenance" v-if="!this.maintenance.create_at">{{ $t('admin_home_page.start_maintenance') }}</v-btn>
              <v-btn color="primary" @click="endMaintenance" v-if="this.maintenance.create_at">{{ $t('admin_home_page.end_maintenance') }}</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab>
        Others
      </v-tab>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col>
              <v-btn block
                     color="error"
                     large
                     @click="clearRedeemRecord">
                CLEAR ALL REDEEM RECORD
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
import _ from 'lodash'
import HkiaraceHomePageSetting from "../Hkiarace/HkiaraceHomePageSetting";
import TinyMceEditor from "../../../components/TinyMceEditor";
import HkiaraceBannerSetting from "../../../components/hkiarace/HkiaraceBannerSetting";
import {DateTime} from "luxon";
import HkiaraceBanner from "@/views/admin/Settings/HkiaraceBanner";

const uuid4 = require('uuid/v4');

library.add(faChevronCircleLeft);

export default {
  name: 'AccBookingSettings',
  components: {HkiaraceBanner, HkiaraceBannerSetting, TinyMceEditor, HkiaraceHomePageSetting},
  data() {
    return {
      fields: [
        'in_advance_booking_period',
        // 'booking_limit_user',
        'booking_limit_day',
        // 'booking_limit_month',
        'no_show_penalty_limit',
        'no_show_penalty_period',
        'no_show_penalty_suspension_period',
        'booking_reminder',
        'coupon_expiry_period',
        'acc_membership_price',
        'acc_membership_period',
        'hkiarace_membership_renew_reminder',
      ],

      topUpOptions: [],

      tnc: null,
      settings: null,
      disabled: [],

      maintenance: null,
    };
  },
  mounted() {
    this.getTNC();
    this.getSettings();
    this.getMaintenance();
  },
  computed: {
    currentMaintenanceStatus() {
      if (this.maintenance.create_at) {
        return this.$t('admin_home_page.maintenance_enabled', {'create_at': DateTime.fromISO(this.maintenance.create_at).toFormat('yyyy-MM-dd HH:mm')});
      } else {
        return this.$t('admin_home_page.maintenance_disabled');
      }
    },
  },
  methods: {
    getTNC() {
      this.$callAPI('hkiarace/tnc/', {}, function (response) {
        this.tnc = response.body;
      });
    },
    saveTNC() {
      this.$callAPI('hkiarace/admin/tnc/set/', {
        title_en: this.tnc.title_en,
        content_en: this.tnc.content_en,
        title_zh: this.tnc.title_zh,
        content_zh: this.tnc.content_zh,
        privacy_title_en: this.tnc.privacy_title_en,
        privacy_content_en: this.tnc.privacy_content_en,
        privacy_title_zh: this.tnc.privacy_title_zh,
        privacy_content_zh: this.tnc.privacy_content_zh,
      }, function (response) {
        this.$showAlertMessage(this.$t('admin_acc_settings.settings_saved'));
      });
    },
    getSettings() {
      this.$callAPI('aafb/admin/settings/', {}, function (response) {
        this.settings = response.body.settings;

        let disabled = [];

        var v = this;
        this.fields.forEach(function (f) {
          if (v.settings[f] === -1) {
            disabled.push(f);
          }
        });
        this.disabled = disabled;

        this.topUpOptions = JSON.parse(this.settings.acc_point_top_up_options) || [];
      });
    },
    onCheckboxChecked(e, field) {
      let index = this.disabled.indexOf(field);

      if (e.target.checked && index === -1) {
        this.disabled.push(field);
      } else if (!e.target.checked && index !== -1) {
        this.disabled.splice(index, 1);
      }
    },
    addTopUpTier() {
      this.topUpOptions.push({id: uuid4(), price: null, amount: null});
    },
    removeTopUpTier(index) {
      this.topUpOptions.splice(index, 1);
    },
    saveSettings() {
      let settings = _.assign({}, this.settings);

      settings.acc_point_top_up_options = JSON.stringify(this.topUpOptions);

      this.disabled.forEach(function (f) {
        settings[f] = -1
      });

      if (confirm(this.$t('admin_acc_settings.confirm_save_msg'))) {
        this.$callAPI('aafb/admin/settings/set/', settings, function (response) {
          this.$showAlertMessage(this.$t('admin_acc_settings.settings_saved'));
        });
      }
    },
    getMaintenance() {
      this.$callAPI('aafb/admin/maintenance/', {}, function (response) {
        this.maintenance = response.body.maintenance;
      });
    },
    startMaintenance() {
      if (confirm(this.$t('admin_home_page.confirm_start_maintenance_msg'))) {
        this.$callAPI('aafb/admin/maintenance/start/', {}, function (response) {
          this.getMaintenance();
        });
      }
    },
    endMaintenance() {
      if (confirm(this.$t('admin_home_page.confirm_end_maintenance_msg'))) {
        this.$callAPI('aafb/admin/maintenance/end/', {}, function (response) {
          this.getMaintenance();
        });
      }
    },
    clearRedeemRecord() {
      if (confirm('Clear All Redeem Welcome Gift Records?')) {
        this.$callAPI('hkiarace/admin/user/clear_redeem_gift/', {}, function (response) {
          this.$showAlertMessage('Successfully Cleared');
        })
      }
    },
  },
}
</script>

<style lang="less">
.admin-settings {
  height: calc(100% - 110px);
  /*display: flex;*/

  /*padding: 30px;*/

  .admin-settings-inner-wrapper {
    height: 100%;
    overflow: scroll;
  }
}

.countdown {
  text-align: right;
}
</style>
